import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

export function useDeleteDataset({ callApiWithWorker, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["deleteDataset"],

    mutationFn: async ({ id }) => {
      if (!id) throw new Error("Missing dataset id");

      const res = await callApiWithWorker(`/datasets/${encodeURIComponent(id)}`, {
        method: "DELETE",
      });

      const status =
        res?.statusCode ??
        res?.data?.statusCode ??
        res?.status ??
        res?.data?.status;

      if (typeof res?.ok === "boolean" && !res.ok) {
        const e = new Error(`Delete failed (${status ?? "unknown"})`);
        e.statusCode = status;
        e.response = res;
        throw e;
      }

      if (status && status >= 400) {
        const e = new Error(`Delete failed (${status})`);
        e.statusCode = status;
        e.response = res;
        throw e;
      }

      return res;
    },

    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ["datasets"] });
      queryClient.invalidateQueries({ queryKey: ["dataOfferings"] });

      if (vars?.id) {
        queryClient.invalidateQueries({
          queryKey: ["dataset", vars.id],
        });
      }

      showSuccessToast(t?.("common.deleteSuccessMessage") || "Deleted successfully", {
        title: t?.("common.deleteSuccessTitle") || "Deleted!",
      });
    },

    onError: (err) => {
      showErrorAlert(err, t);
    },
  });
}
